import { Pipe, PipeTransform } from '@angular/core';
import type { Organization, OrganizationGroup } from '../services/users/users.service';

@Pipe({ name: 'displayOrgName', pure: true })
export class DisplayOrgNamePipe implements PipeTransform {
  transform(value: Organization | OrganizationGroup | null | undefined): string {
    if (!value) return '—';
    if ('ORGANIZATION_NAME' in value) return value.ORGANIZATION_NAME || '—';
    return value.GROUP_NAME || '—';
  }
}
